import {Component, Input} from '@angular/core';
import {User} from '../../model/user';
import {Version} from '../../model/version';

@Component({
    selector: 'mir-shortcuts-bar',
    templateUrl: './shortcuts-bar.component.html',
    styleUrls: ['./shortcuts-bar.component.css'],
    standalone: false
})
export class ShortcutsBarComponent {

  @Input()
  user: User;

  @Input()
  version: Version;

}
